var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuote = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 6.5C3 5.67157 3.67157 5 4.5 5H6.5V8.5C6.5 10.433 5.433 11.5 3.5 11.5M10 6.5C10 5.67157 10.6716 5 11.5 5H13.5V8.5C13.5 10.433 12.433 11.5 10.5 11.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuote);
export default ForwardRef;